import React, { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useGetPassedActivities } from "../../hooks/useCrm";
import PassedActivityActions from "../PassedActivityActions/PassedActivityActions";
import PassedActivityChances from "../PassedActivityChances/PassedActivityChances";
import PassedActivityVisits from "../PassedActivityVisits/PassedActivityVisits";
import { TabWrapper } from "../TodayActivitiesTab/TodayActivitiesTabStyle";

const PassedActivitiesTab = () => {
  const {
    data: actions,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetPassedActivities();

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;

        if (hasNextPage) await fetchNextPage();

        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);
  return (
    <TabWrapper>
      <Tabs
        defaultActiveKey="actions"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="actions" title="فعالیت های گذشته">
          <PassedActivityActions data={actions} isLoading={isLoading} />
        </Tab>
        <Tab eventKey="history" title="فرصت های گذشته">
          <PassedActivityChances data={actions} isLoading={isLoading} />
        </Tab>
        <Tab eventKey="invoice" title="ویزیت های گذشته">
          <PassedActivityVisits data={actions} isLoading={isLoading} />
        </Tab>
      </Tabs>
    </TabWrapper>
  );
};

export default PassedActivitiesTab;
